export default "/img_score_20.png";